import PropTypes from "prop-types";
import React from "react";

import { DeviceInfoProvider } from "@swa-ui/browser";
import { DesignTokensThemeProvider } from "@swa-ui/design-tokens";

import { ConfigurationProvider } from "../ConfigurationContext";
import { OverlayProvider } from "../OverlayProvider";

/**
 * All providers used by the core. Applications will use this to set up providers.
 * Future providers can be added here without any app changes.
 */

export const CoreProviders = (props) => {
  const { children, configuration, deviceInfoConfiguration, overlayConfiguration } = props;

  return (
    <ConfigurationProvider configuration={configuration}>
      <OverlayProvider overlayConfiguration={overlayConfiguration}>
        <DeviceInfoProvider {...deviceInfoConfiguration}>
          <DesignTokensThemeProvider>{children}</DesignTokensThemeProvider>
        </DeviceInfoProvider>
      </OverlayProvider>
    </ConfigurationProvider>
  );
};

CoreProviders.displayName = "CoreProviders";

CoreProviders.propTypes = {
  /** Content that will be rendered with all core context providers. */
  children: PropTypes.node,

  /** Configuration object used to configure the core. */
  configuration: PropTypes.shape({
    iconMapping: PropTypes.object,
  }),

  /** DeviceInfoProvider configuration used to configure device info processing. */
  deviceInfoConfiguration: PropTypes.object,

  /** OverlayProvider configuration used to configure overlay display settings. */
  overlayConfiguration: PropTypes.object,
};

CoreProviders.defaultProps = {
  deviceInfoConfiguration: {},
  overlayConfiguration: {},
};
